import { Outlet } from '@tanstack/react-router';
import { ErrorState } from '../ui';
import { useProject } from '../../features/projects/api';

/**
 * Project workspace frame.
 *
 * It renders no navigation of its own: the sidebar is the single navigation
 * column of the application, and it already names the open project and marks it
 * when archived. What is left here is loading the project so that an unknown or
 * deleted code fails once, with an error state, instead of in every child page.
 */
export const ProjectLayout = ({ projectCode }: { projectCode: string }) => {
  const { error, refetch } = useProject(projectCode);

  if (error) return <ErrorState error={error} onRetry={() => void refetch()} />;

  return <Outlet />;
};
